// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"styles/variables.css\"","fourth-table-shrink-width":"870px","column":"LinksColumn_column__ln8UU"};